import { startOfDay, subDays } from 'date-fns';
import dataService from 'services/dataService';
import { NEW_PATIENTS_CSV_REPORT } from 'services/dataService/resources';
import { useMutation } from '@tanstack/react-query';
import { showResult } from 'infrastructure/hooks/utils';

import type { TNewPatientsReportFilter } from './use-get-new-patients-report';

const prepareFilters = (filters?: TNewPatientsReportFilter) => {
  if (!filters) return {};
  const copiedFilters = structuredClone(filters);

  if (copiedFilters.range) {
    copiedFilters.startTime = subDays(
      startOfDay(new Date()),
      copiedFilters.range,
    ).getTime();
    delete copiedFilters.range;
  }
  return copiedFilters;
};

export const useNewPatientsSendReport = (filters: TNewPatientsReportFilter) => {
  const { mutate, isLoading } = useMutation({
    mutationFn: async () => {
      const preparedPostData = prepareFilters(filters);
      const { error, data } = await dataService.createOne(
        NEW_PATIENTS_CSV_REPORT,
        preparedPostData,
      );
      if (error) {
        showResult(error);
        return;
      }
      return data;
    },
  });

  return {
    isLoading,
    sendReportToEmail: mutate,
  };
};
